import { useDispatch, useSelector } from "react-redux";
import FoodItem from "./FoodItem";
import { useState } from "react";
import { clearCart } from "../utils/cartSlice";
import { removeItem } from "../utils/cartSlice";
import { addItem } from "../utils/cartSlice";
const Cart=()=>{

    const cartItems=useSelector(store=>store.cart.items);
    console.log("cart rendered!")
   // const [showItems,setShowItems]=useState([])
    const dispatch=useDispatch()
    const clear=()=>{
        dispatch(clearCart());
    }
    console.log(cartItems)
    const counts = {};
   cartItems.forEach((item) => {
        const id = item.card.info.id; // or use item.card.info.name to count by name
        counts[id] = (counts[id] || 0) + 1;
    });
    
    // Step 2: Create ancartItemsay of unique objects with their count
    const uniqueArr =cartItems.reduce((acc, item) => {
        const id = item.card.info.id; // or use item.card.info.name if counting by name
        if (!acc.some((obj) => obj.card.info.id === id)) {
            const newItem = JSON.parse(JSON.stringify(item)); // Clone the object to avoid mutation
            newItem.card.info.count = counts[id]; // Add the count property
            acc.push(newItem);
        }
        return acc;
    }, []);
console.log("uniqueArr:",uniqueArr)
//setShowItems(uniqueArr)
    return(
        <div className="dark:bg-slate-900 min-h-full">
         { uniqueArr.map((item)=>{
            {console.log("key: ",item?.card?.info?.id," count: ",item.card.info.count)}
            return(
                <div key={item?.card?.info?.id} className="p-2 w-6/12 flex bg-slate-300 border-b-2 border-black m-1 rounded shadow-lg items-center">
                <FoodItem {...item?.card?.info} />
                <button onClick={()=>dispatch(addItem(item))} className="p-1 bg-slate-200 rounded m-1 h-1/3 hover:bg-white">➕</button>
                <button onClick={()=>dispatch(removeItem(item?.card?.info?.id))} className="p-1 bg-slate-200 rounded m-1 h-1/3 hover:bg-white" >➖</button>
      </div>
            )
            
          })}
          {uniqueArr.length!=0&&<button onClick={()=>{
            clear()
          }} className="p-2 m-1 rounded bg-slate-300 shadow-lg">Clear Cart</button>}
        </div>
    )
}
export default Cart;